module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec08_98ab540b1b4e250fd077bcbba57d23b4.jpg";